import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext({
    lang: "de",
    setLang: () => {},
    t: translations.de,
});

export const LanguageProvider = ({ children }) => {
    const [lang, setLangState] = useState(() => {
        try {
            const stored = localStorage.getItem("ella_lang");
            return stored === "es" || stored === "de" ? stored : "de";
        } catch {
            return "de";
        }
    });

    const setLang = (next) => {
        setLangState(next);
        try {
            localStorage.setItem("ella_lang", next);
        } catch {
            // ignore
        }
    };

    useEffect(() => {
        document.documentElement.lang = lang;
    }, [lang]);

    const value = {
        lang,
        setLang,
        t: translations[lang] || translations.de,
    };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
